import { AcordoAccordion } from "./components/acordo";
import { ResumoAcordoAccordion } from "./components/resumo";

export const ResumoAcordo = () => {
  return (
    <div>
      <ResumoAcordoAccordion />
      <AcordoAccordion />
    </div>
  );
};
